exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-templates-marketing-page-jsx": () => import("./../../../src/templates/marketingPage.jsx" /* webpackChunkName: "component---src-templates-marketing-page-jsx" */)
}

